import { Typography } from "@mui/material"
import { StyledMessageBubble } from "../ConversationArea.styled"


const LoadingMessage = () => {
  return (
    <StyledMessageBubble fromUser={false}>
      <Typography variant="body2" color="textSecondary">
        Antwort wird generiert...
      </Typography>
    </StyledMessageBubble>
  )
}
export default LoadingMessage;